import React,{ Component } from 'react';
import IMG01 from '../../../assets/images/patients/patient1.jpg';

import { Link } from 'react-router-dom';
class PatientSidebar extends Component{
    render(){
        return(
            
               	            <div className="card widget-profile pat-widget-profile">
								<div className="card-body">
									<div className="pro-widget-content">
										<div className="profile-info-widget">
											<Link to="#0" className="booking-doc-img">
												<img src={IMG01} alt="User" />
											</Link>
											<div className="profile-det-info">
												<h3>MENDOZA CHOQUE </h3>
												
												<div className="patient-details">
													<h5><b>CI :</b> 6060601</h5>
													<h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> La Paz, Bolivia</h5>
												</div>
											</div>
										</div>
									</div>
									<div className="patient-info">
										<ul>
											<li>Teléfono <span>62468400</span></li>
											<li>Edad <spn>25 años</spn></li>
										 
										</ul>
									</div>
								</div>
							</div>
			
        );
    }
}
export default PatientSidebar;
   